window.__assetPrefix__ = 'https://d3e27mpsxqhlrm.cloudfront.net/vercel-frontend-connection';